import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export interface DataTableAction {
  label: string;
  onClick: () => void;
  icon?: React.ComponentType<{ className?: string }>;
  variant?: "default" | "outline" | "ghost" | "destructive";
  disabled?: boolean;
}

interface DataTableHeaderProps {
  title?: string;
  subtitle?: string;
  badge?: number | string;
  actions?: DataTableAction[];
  headerExtra?: ReactNode;
}

export function DataTableHeader({
  title,
  subtitle,
  badge,
  actions,
  headerExtra,
}: DataTableHeaderProps) {
  return (
    <div className="flex items-start justify-between">
      <div className="space-y-1">
        <div className="flex items-center gap-3">
          {title && <h1 className="text-xl font-bold tracking-tight">{title}</h1>}
          {badge != null && (
            <Badge variant="secondary" className="rounded-full">
              {typeof badge === "number" ? `${badge} records` : badge}
            </Badge>
          )}
        </div>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {headerExtra}
        {actions?.map((action) => (
          <Button
            key={action.label}
            variant={action.variant || "default"}
            onClick={action.onClick}
            disabled={action.disabled}
            size="sm"
          >
            {action.icon && <action.icon className="mr-2 h-4 w-4" />}
            {action.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
